export default __webpack_public_path__ + "static/media/Arrow4.702bcec0.svg";